<template>
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">
import { useHead } from '#imports'

useHead({
  title: 'Vedware',
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { name: 'description', content: '' },
    { name: 'format-detection', content: 'telephone=no' },
    { name: 'theme-color', content: '#3B82F6' },
  ],
  noscript: [{ innerHTML: '<style>.reveal{opacity:1!important}</style>' }],
  link: [
    { rel: 'icon', href: '/favicon.ico', sizes: '48x48' },
    { rel: 'manifest', href: '/site.webmanifest' },
  ],
})
</script>
